import { z } from 'zod'
import { makeFieldKeys, validateWithZodSchema } from '../../core/utils/utilities.ts'
import {
  TABLE_CONTACTS,
  TABLE_CONTACT_ACCOUNTS,
  TABLE_RELATIONSHIP_TYPES,
  FIELD_KEY_SEPARATOR,
  FIELD_KEY_PROG,
  FIELD_KEY_ACTION
} from '../globals.ts'
import { ContactsModelFields } from './contacts_model.ts'
import { ContactAccountsModelFields } from './contact_accounts_model.ts'
import { RelationshipTypesModelFields } from './relationship_types_model.ts'

const ALIAS_CONTACTS = `${TABLE_CONTACTS}${FIELD_KEY_SEPARATOR}` as const
const ALIAS_CONTACT_ACCOUNTS = `${TABLE_CONTACT_ACCOUNTS}${FIELD_KEY_SEPARATOR}` as const
const ALIAS_RELATIONSHIP_TYPES = `${TABLE_RELATIONSHIP_TYPES}${FIELD_KEY_SEPARATOR}` as const

const PROG_FOUNDER = `${FIELD_KEY_PROG}founder` as const
const PROG_ACCOUNT_NAME = `${FIELD_KEY_PROG}account__name` as const
const PROG_NEW_IS_PRIMARY_ID = `${FIELD_KEY_PROG}new_is_primary_id` as const

const PROG_DISPLAY_NAME = `${FIELD_KEY_PROG}display_name` as const
const PROG_CONTACTS_ACTION = `${FIELD_KEY_PROG}${TABLE_CONTACTS}${FIELD_KEY_ACTION}` as const
const PROG_CONTACT_ACCOUNTS_ACTION = `${FIELD_KEY_PROG}${TABLE_CONTACT_ACCOUNTS}${FIELD_KEY_ACTION}` as const

const FIELD_CONTACTS_ID = `${ALIAS_CONTACTS}${ContactsModelFields.id}` as const
const FIELD_CONTACTS_EMAIL = `${ALIAS_CONTACTS}${ContactsModelFields.email}` as const
const FIELD_CONTACTS_LAST_NAME = `${ALIAS_CONTACTS}${ContactsModelFields.last_name}` as const
const FIELD_CONTACTS_FIRST_NAME = `${ALIAS_CONTACTS}${ContactsModelFields.first_name}` as const
const FIELD_CONTACTS_MOBILE_PHONE = `${ALIAS_CONTACTS}${ContactsModelFields.mobile_phone}` as const
const FIELD_CONTACTS_PREFERRED_NAME = `${ALIAS_CONTACTS}${ContactsModelFields.preferred_name}` as const
const FIELD_CONTACTS_PHOTO_URL = `${ALIAS_CONTACTS}${ContactsModelFields.photo_url}` as const

const FIELD_CONTACT_ACCOUNTS_ID = `${ALIAS_CONTACT_ACCOUNTS}${ContactAccountsModelFields.id}` as const
const FIELD_CONTACT_ACCOUNTS_ACCOUNT_ID = `${ALIAS_CONTACT_ACCOUNTS}${ContactAccountsModelFields.account_id}` as const
const FIELD_CONTACT_ACCOUNTS_TITLE = `${ALIAS_CONTACT_ACCOUNTS}${ContactAccountsModelFields.title}` as const
const FIELD_CONTACT_ACCOUNTS_RELATIONSHIP_CATEGORY_ID = `${ALIAS_CONTACT_ACCOUNTS}${ContactAccountsModelFields.relationship_category_id}` as const
const FIELD_CONTACT_ACCOUNTS_CURRENT = `${ALIAS_CONTACT_ACCOUNTS}${ContactAccountsModelFields.current}` as const
const FIELD_CONTACT_ACCOUNTS_IS_PRIMARY = `${ALIAS_CONTACT_ACCOUNTS}${ContactAccountsModelFields.is_primary}` as const

const FIELD_RELATIONSHIP_TYPES_ID = `${ALIAS_RELATIONSHIP_TYPES}${RelationshipTypesModelFields.id}` as const

export const CompanyTeamEntrySchema = z
  .object({
    [FIELD_CONTACTS_ID]: z.string().nullish(),
    [FIELD_CONTACTS_EMAIL]: z.string().nullish(),
    [FIELD_CONTACTS_LAST_NAME]: z.string().nullish(),
    [FIELD_CONTACTS_FIRST_NAME]: z.string().nullish(),
    [FIELD_CONTACTS_MOBILE_PHONE]: z.string().nullish(),
    [FIELD_CONTACTS_PREFERRED_NAME]: z.string().nullish(),
    [FIELD_CONTACTS_PHOTO_URL]: z.string().nullish(),
    [FIELD_CONTACT_ACCOUNTS_ID]: z.string().nullish(),
    [FIELD_CONTACT_ACCOUNTS_ACCOUNT_ID]: z.string().nullish(),
    [FIELD_CONTACT_ACCOUNTS_TITLE]: z.string().nullish(),
    [FIELD_CONTACT_ACCOUNTS_RELATIONSHIP_CATEGORY_ID]: z.string().nullish(),
    [FIELD_CONTACT_ACCOUNTS_CURRENT]: z.boolean().nullish(),
    [FIELD_CONTACT_ACCOUNTS_IS_PRIMARY]: z.boolean().nullish(),
    [FIELD_RELATIONSHIP_TYPES_ID]: z.string().nullish(),
    [PROG_FOUNDER]: z.boolean().nullish(),
    [PROG_ACCOUNT_NAME]: z.string().nullish(), // TODO: needs to change
    [PROG_NEW_IS_PRIMARY_ID]: z.string().nullish(),
    [PROG_DISPLAY_NAME]: z.string().nullish(), // TODO: What is this?
    [PROG_CONTACT_ACCOUNTS_ACTION]: z.string().nullish(),
    [PROG_CONTACTS_ACTION]: z.string().nullish()
  })
  .strict()

export const CompanyTeamEntryFields = makeFieldKeys(CompanyTeamEntrySchema)

export type CompanyTeamEntry = z.infer<typeof CompanyTeamEntrySchema>

export function validateCompanyTeamEntry(data: unknown): CompanyTeamEntry {
  try {
    return validateWithZodSchema(CompanyTeamEntrySchema, data, 'company team entry')
  } catch (error) {
    throw new Error(`Company team entry validation failed: ${error}`)
  }
}
